<template>
    <v-app>
        <Drawer current_item="menu_appointment_list" :mini="true"></Drawer>
        <v-dialog eager v-model="dialog_create_appointment" persistent max-width="1024">
            <DialogCreateAppointment 
                ref="dialog_create_appointment" 
                @onclosed="onCreateAppointmentClosed" 
                @oncreatemember="onCreateMemberOpen"
                @onsuccess="onCreateAppointmentSuccess" 
                :station_code="$route.params.station_code"
            ></DialogCreateAppointment>     
        </v-dialog>
        <v-dialog v-model="dialog_create_member" persistent max-width="1280">
            <FragmentCreateMember 
                @onclosed="onCreateMemberClosed" 
                @onsuccess="onCreateMemberSuccess" 
                :station_code="$route.params.station_code"
            ></FragmentCreateMember>
        </v-dialog>
        <v-dialog v-model="dialog_continue_appointment" persistent max-width="480">
            <v-card>
                <v-card-title class="headline">{{ $t('is_continue_reservation') }}</v-card-title>
                <v-card-actions align="center">
                    <v-spacer></v-spacer>
                    <v-btn color="grey" @click="dialog_continue_appointment = false">{{ $t('no_continue_reservation') }}</v-btn>
                    <v-btn color="green" @click="onContinueAppointment">{{ $t('yes_continue_reservation') }}</v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialog_appointment_edit_station" max-width="900">
            <v-card class="pa-4">
                <FragmentSelectStation :station_code="editStationStationCode" @onchange="(station) => {editStationGroupId = null;editStationStationCode = station.station_code;$refs.edit_station_group.reload();}"></FragmentSelectStation>
                <FragmentSelectGroup ref="edit_station_group" @ongroup="(group) => editStationGroupId = group.group_id" :station_code="editStationStationCode" :have_group_0="false"></FragmentSelectGroup>
                <v-row class="mt-2">
                    <v-col cols="9">
                        <div>วันที่นัดหมาย : {{ edit_station_editDateDate == null ? 'คงเดิม' : edit_station_editDateDate }}</div>
                        <div>ช่วงเวลาที่นัดหมาย : {{ edit_station_editDateTimeStart == null && edit_station_editDateTimeEnd == null ? 'คงเดิม' : (edit_station_editDateTimeStart == null ? '???' : ('0000' + edit_station_editDateTimeStart).substring((''+edit_station_editDateTimeStart).length,(''+edit_station_editDateTimeStart).length+2)+':'+('0000' + edit_station_editDateTimeStart).substring((''+edit_station_editDateTimeStart).length+2,(''+edit_station_editDateTimeStart).length+4)) + ' - ' + (edit_station_editDateTimeEnd == null ? '???' : ('0000' + edit_station_editDateTimeEnd).substring((''+edit_station_editDateTimeEnd).length,(''+edit_station_editDateTimeEnd).length+2)+':'+('0000' + edit_station_editDateTimeEnd).substring((''+edit_station_editDateTimeEnd).length+2,(''+edit_station_editDateTimeEnd).length+4)) }}</div>
                    </v-col>
                    <v-col cols="3" align="left">
                        <v-btn color="primary" @click="edit_station_editdatetime=!edit_station_editdatetime">แก้ไข</v-btn>
                    </v-col>
                </v-row>
                
                <FragmentSelectDateGroupTime v-if="edit_station_editdatetime"
                    @ondate="(date) => edit_station_editDateDate = date" 
                    @ontimestart="(timestart) => edit_station_editDateTimeStart = timestart" 
                    @ontimeend="(timeend) => edit_station_editDateTimeEnd = timeend" 
                    :station_code="editStationStationCode"
                    :disable_group="true"
                    ref="dialog_appointment_edit_station"
                ></FragmentSelectDateGroupTime>
                <v-btn class="mt-4" color="primary" @click="appointmentEditStation" :disabled="!isReady_station">ตกลง</v-btn>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialog_appointment_edit_date" max-width="900">
            <v-card class="pa-4">
                <FragmentSelectDateGroupTime 
                    @ondate="(date) => editDateDate = date" 
                    @ontimestart="(timestart) => editDateTimeStart = timestart" 
                    @ontimeend="(timeend) => editDateTimeEnd = timeend" 
                    :station_code="$route.params.station_code"
                    :disable_group="true"
                    ref="dialog_appointment_edit_date"
                ></FragmentSelectDateGroupTime>
                <v-btn color="primary" @click="appointmentEditDate" :disabled="!isReady">ตกลง</v-btn>
            </v-card>
        </v-dialog>

        <v-dialog
        v-model="dialog_action_confirm"
        persistent
        scrollable
        max-width="600"
      >
          <v-card>
              <v-card-title>
                  กรุณายืนยันที่จะต้องการปฏิเสธ/ยกเลิกนัดหมายที่เลือก
              </v-card-title>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="red darken-1"
                  text
                  @click="dialog_action_confirm=false"
                >
                  ยกเลิก
                </v-btn>
                <v-btn
                  color="green darken-1"
                  text
                  @click="dialog_action_confirm=false;appointmentAction(8);"
                >
                  ยืนยัน
                </v-btn>
              </v-card-actions>
          </v-card>
      </v-dialog>
        <v-main class="ma-6">

        <v-card>
            <v-card-title>
                <v-row>
                    <v-col cols="12" md="4">
                        <FragmentSelectStation :station_code="$route.params.station_code" @onchange="onStationChange"></FragmentSelectStation>
                    </v-col>
                    <v-col cols="12" md="8">
                        <FragmentLinecount :station_code="$route.params.station_code"></FragmentLinecount>
                    </v-col>
                </v-row>
            </v-card-title>
        <v-divider ></v-divider>

        <v-row >
            <v-col cols="12" md="8" class="criteria" >
                <v-tabs
                    fixed-tabs
                    v-model="tab"
                    background-color="indigo"
                    dark
                >
                    <v-tab key="tab1">
                        นัดหมายวันนี้
                    </v-tab>
                    <v-tab key="tab2">
                        มาถึงแล้ววันนี้
                    </v-tab>
                    <v-tab key="tab3">
                        นัดหมายรอที่รอตอบรับ
                    </v-tab>
                    <v-tab key="tab4">
                        ค้นหานัดหมาย
                    </v-tab>
                </v-tabs>
            </v-col>
            <v-col cols="12" md="1" class="text-right ml-n4">
                <v-btn v-if="permission.includes('CREATE_reservation_list')  && permission.includes('VIEW_member_list')" depressed  color="primary" @click.stop="onCreateAppointmentOpen">{{ $t('add_appointment') }}</v-btn>
            </v-col>
            <v-col cols="12" md="1" class="text-right ml-4">
                <v-btn v-if="permission.includes('CREATE_member_list')" depressed  color="primary" @click.stop="onCreateMemberOpen">{{ $t('add_member') }}</v-btn>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="12" md="2" class="text-subtitle-2">
                {{ $t('last_reload') }} {{last_reload}}
                <v-btn tile icon @click="tableReload('all')"><v-icon>mdi-refresh</v-icon></v-btn>
            </v-col>
        </v-row >

        <!--<v-card-text>
                    <FragmentCalendar 
                        ref="calendar"
                        @oncalendar="onCalendar"
                        :station_code="$route.params.station_code"
                    ></FragmentCalendar>
                    <v-card style="margin-top:5px;">
                        <v-card-title style="padding-left: 10px;">
                            <v-row >
                                <v-col cols="12" md="4" class="criteria" >
                                    <FragmentSelectGroup @ongroup="onGroup" :station_code="$route.params.station_code"></FragmentSelectGroup>
                                </v-col>
                                <v-col cols="12" md="4" class="criteria">
                                    <FragmentSelectTimeRange
                                        @ontimestart="onTimestart"
                                        @ontimeend="onTimeend"
                                    ></FragmentSelectTimeRange>
                                </v-col>
                                <v-spacer></v-spacer>
                                <v-col cols="12" md="2" class="text-subtitle-2">
                                    {{ $t('last_reload') }} {{last_reload}}
                                    <v-btn tile icon @click="tableReload('all')"><v-icon>mdi-refresh</v-icon></v-btn>
                                </v-col>
                            </v-row>
                        </v-card-title>
                        <v-card-title class="criteria ">
                            <v-col class="criteria" cols="12" md="2">
                                <v-switch v-model="criteria.isConfirm" class="ma-2" label="ตอบรับนัดแล้ว" @change="(val) => onStatus(val==true,['2'])"></v-switch>
                            </v-col>
                            <v-col class="criteria" cols="12" md="2">
                                <v-switch v-model="criteria.isWaiting" class="ma-2" label="รอตอบรับนัด" @change="(val) => onStatus(val==true,['1','6'])"></v-switch>
                            </v-col>
                            <v-col class="criteria" cols="12" md="2">
                                <v-switch v-model="criteria.isCancel" class="ma-2" label="ยกเลิกนัดแล้ว" @change="(val) => onStatus(val==true,['3','7','8','9'])"></v-switch>
                            </v-col>
                            <v-col class="criteria" cols="12" md="2">
                                <v-switch v-model="criteria.isCheckIn" class="ma-2" label="มาถึงแล้ว" @change="(val) => onStatus(val==true,['4','5'])"></v-switch>
                            </v-col>
                            
                            
                                
            <v-col class="text-right">
                                    <v-menu offset-y>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn style="color:white" depressed v-bind="attrs" v-on="on" color="purple" :disabled="action_items.length==0">{{ $t('appointment_action') }}</v-btn>
                                        </template>
                                        <v-list>
                                            <v-list-item
                                                v-for="(item, index) in action_items"
                                                :key="index"
                                                @click="appointmentAction(item)"
                                            >
                                            <v-list-item-title>{{ $t('tag_action_' + item) }}</v-list-item-title>
                                            </v-list-item>
                                        </v-list>
                                    </v-menu>
                                </v-col>
                                <v-col class="text-right">
                <v-btn v-if="permission.includes('CREATE_reservation_list')  && permission.includes('VIEW_member_list')" depressed  color="primary" @click.stop="onCreateAppointmentOpen">{{ $t('add_appointment') }}</v-btn>
            </v-col>
                                <v-col class="text-right">
                                    <v-btn v-if="permission.includes('CREATE_member_list')" depressed  color="primary" @click.stop="onCreateMemberOpen">{{ $t('add_member') }}</v-btn>
                                </v-col>
                        </v-card-title>
                        <v-divider style="margin-left:10px;margin-right:10px;"></v-divider>
                        <v-card-text style="background-color:#d5f0ff">
                            <FragmentAppointmentTable 
                                eager
                                ref="table" 
                                :query="query"
                                :station_code="$route.params.station_code"
                                @ontable="onTable"
                            ></FragmentAppointmentTable>
                        </v-card-text>
                    </v-card>
                </v-card-text>-->

        <v-tabs-items v-model="tab">
            <v-tab-item eager key="tab1">
                <v-card-text>
                    <v-card style="margin-top:5px;">
                        <v-card-title style="padding-left: 10px;">
                            <v-row >
                                <v-col cols="12" md="4" class="criteria" >
                                    <FragmentSelectGroup @ongroup="gr=>onGroup(gr,1)" :station_code="$route.params.station_code"></FragmentSelectGroup>
                                </v-col>
                                <v-col cols="12" md="4" class="criteria">
                                    <FragmentSelectTimeRange
                                        @ontimestart="tm=>onTimestart(tm,1)"
                                        @ontimeend="tm=>onTimeend(tm,1)"
                                    ></FragmentSelectTimeRange>
                                </v-col>
                                <v-spacer></v-spacer>
                                <v-col class="text-right">
                                    <v-menu offset-y>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn style="color:white" depressed v-bind="attrs" v-on="on" color="purple" :disabled="action_items_1.length==0">{{ $t('appointment_action') }}</v-btn>
                                        </template>
                                        <v-list>
                                            <v-list-item
                                                v-for="(item, index) in action_items_1"
                                                :key="index"
                                                @click="appointmentAction(item,1)"
                                            >
                                            <v-list-item-title>{{ $t('tag_action_' + item) }}</v-list-item-title>
                                            </v-list-item>
                                        </v-list>
                                    </v-menu>
                                </v-col>
                            </v-row>
                        </v-card-title>
                        <v-divider style="margin-left:10px;margin-right:10px;"></v-divider>
                        <v-card-text style="background-color:#d5f0ff">
                            <FragmentAppointmentTable 
                                eager
                                ref="table_1" 
                                :query="query_1"
                                :station_code="$route.params.station_code"
                                @ontable="tb=>onTable(tb,1)"
                            ></FragmentAppointmentTable>
                        </v-card-text>
                    </v-card>
                </v-card-text>
            </v-tab-item>
                <v-tab-item eager key="tab2">
                <v-card-text>
                    <v-card style="margin-top:5px;">
                        <v-card-title style="padding-left: 10px;">
                            <v-row >
                                <v-col cols="12" md="4" class="criteria" >
                                    <FragmentSelectGroup @ongroup="gr=>onGroup(gr,2)" :station_code="$route.params.station_code"></FragmentSelectGroup>
                                </v-col>
                                <v-col cols="12" md="4" class="criteria">
                                    <FragmentSelectTimeRange
                                        @ontimestart="tm=>onTimestart(tm,2)"
                                        @ontimeend="tm=>onTimeend(tm,2)"
                                    ></FragmentSelectTimeRange>
                                </v-col>
                                <v-spacer></v-spacer>
                                <v-col class="text-right">
                                    <v-menu offset-y>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn style="color:white" depressed v-bind="attrs" v-on="on" color="purple" :disabled="action_items_2.length==0">{{ $t('appointment_action') }}</v-btn>
                                        </template>
                                        <v-list>
                                            <v-list-item
                                                v-for="(item, index) in action_items_2"
                                                :key="index"
                                                @click="appointmentAction(item,2)"
                                            >
                                            <v-list-item-title>{{ $t('tag_action_' + item) }}</v-list-item-title>
                                            </v-list-item>
                                        </v-list>
                                    </v-menu>
                                </v-col>
                            </v-row>
                        </v-card-title>
                        <v-divider style="margin-left:10px;margin-right:10px;"></v-divider>
                        <v-card-text style="background-color:#d5f0ff">
                            <FragmentAppointmentTable 
                                eager
                                ref="table_2" 
                                :query="query_2"
                                :station_code="$route.params.station_code"
                                @ontable="tb=>onTable(tb,2)"
                            ></FragmentAppointmentTable>
                        </v-card-text>
                    </v-card>
                </v-card-text>                </v-tab-item>
            <v-tab-item eager key="tab3">
                <v-card-text>
                    <v-card style="margin-top:5px;">
                        <v-card-title style="padding-left: 10px;">
                            <v-row >
                                <v-col cols="12" md="4" class="criteria" >
                                    <FragmentSelectGroup @ongroup="gr=>onGroup(gr,3)" :station_code="$route.params.station_code"></FragmentSelectGroup>
                                </v-col>
                                <v-col cols="12" md="4" class="criteria">
                                    <FragmentSelectTimeRange
                                        @ontimestart="tm=>onTimestart(tm,3)"
                                        @ontimeend="tm=>onTimeend(tm,3)"
                                    ></FragmentSelectTimeRange>
                                </v-col>
                                <v-spacer></v-spacer>
                                <v-col class="text-right">
                                    <v-menu offset-y>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn style="color:white" depressed v-bind="attrs" v-on="on" color="purple" :disabled="action_items_3.length==0">{{ $t('appointment_action') }}</v-btn>
                                        </template>
                                        <v-list>
                                            <v-list-item
                                                v-for="(item, index) in action_items_3"
                                                :key="index"
                                                @click="appointmentAction(item,3)"
                                            >
                                            <v-list-item-title>{{ $t('tag_action_' + item) }}</v-list-item-title>
                                            </v-list-item>
                                        </v-list>
                                    </v-menu>
                                </v-col>
                            </v-row>
                        </v-card-title>
                        <v-divider style="margin-left:10px;margin-right:10px;"></v-divider>
                        <v-card-text style="background-color:#d5f0ff">
                            <FragmentAppointmentTable 
                                eager
                                ref="table_3" 
                                :query="query_3"
                                :station_code="$route.params.station_code"
                                @ontable="tb=>onTable(tb,3)"
                            ></FragmentAppointmentTable>
                        </v-card-text>
                    </v-card>
                </v-card-text>
                        </v-tab-item>
            <v-tab-item eager key="tab4">
        
                <v-card-text>
                    <FragmentCalendar 
                        ref="calendar"
                        @oncalendar="onCalendar"
                        :station_code="$route.params.station_code"
                    ></FragmentCalendar>
                    <v-card style="margin-top:5px;">
                        <v-card-title style="padding-left: 10px;">
                            <v-row >
                                <v-col cols="12" md="4" class="criteria" >
                                    <FragmentSelectGroup @ongroup="onGroup" :station_code="$route.params.station_code"></FragmentSelectGroup>
                                </v-col>
                                <v-col cols="12" md="4" class="criteria">
                                    <FragmentSelectTimeRange
                                        @ontimestart="onTimestart"
                                        @ontimeend="onTimeend"
                                    ></FragmentSelectTimeRange>
                                </v-col>
                                <v-spacer></v-spacer>
                                <v-col class="text-right">
                                    <v-menu offset-y>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn style="color:white" depressed v-bind="attrs" v-on="on" color="purple" :disabled="action_items.length==0">{{ $t('appointment_action') }}</v-btn>
                                        </template>
                                        <v-list>
                                            <v-list-item
                                                v-for="(item, index) in action_items"
                                                :key="index"
                                                @click="appointmentAction(item,0)"
                                            >
                                            <v-list-item-title>{{ $t('tag_action_' + item) }}</v-list-item-title>
                                            </v-list-item>
                                        </v-list>
                                    </v-menu>
                                </v-col>
                            </v-row>
                            <v-row >
                                <v-col cols="12" md="10" class="criteria" >
                                    <v-select v-model="selectedStatus" :items="status_items" label="สถานะของนัดหมาย" 
                                        item-text="name"
                                        item-value="value" multiple chips>
                                    </v-select>
                                </v-col>
                                <v-col cols="12" md="1" class="text-subtitle-2">
                                    <div>ค้นหาเมื่อ</div>
                                    <div>{{last_search}}</div>
                                </v-col>
                                <v-spacer></v-spacer>
                                <v-col class="text-right">
                                    <v-btn style="color:white" depressed @click="tableReload(0)" color="purple">ค้นหา</v-btn>
                                </v-col>
                            </v-row>
                        </v-card-title>
                        <!--<v-card-title class="criteria ">
                            <v-col class="criteria" cols="12" md="2">
                                <v-switch v-model="criteria.isConfirm" class="ma-2" label="ตอบรับนัดแล้ว" @change="(val) => onStatus(val==true,['2'])"></v-switch>
                            </v-col>
                            <v-col class="criteria" cols="12" md="2">
                                <v-switch v-model="criteria.isWaiting" class="ma-2" label="รอตอบรับนัด" @change="(val) => onStatus(val==true,['1','6'])"></v-switch>
                            </v-col>
                            <v-col class="criteria" cols="12" md="2">
                                <v-switch v-model="criteria.isCancel" class="ma-2" label="ยกเลิกนัดแล้ว" @change="(val) => onStatus(val==true,['3','7','8','9'])"></v-switch>
                            </v-col>
                            <v-col class="criteria" cols="12" md="2">
                                <v-switch v-model="criteria.isCheckIn" class="ma-2" label="มาถึงแล้ว" @change="(val) => onStatus(val==true,['4','5'])"></v-switch>
                            </v-col>
                        </v-card-title>-->
                        <v-divider style="margin-left:10px;margin-right:10px;"></v-divider>
                        <v-card-text style="background-color:#d5f0ff">
                            <FragmentAppointmentTable 
                                eager
                                ref="table" 
                                :query="query"
                                :station_code="$route.params.station_code"
                                @ontable="onTable"
                            ></FragmentAppointmentTable>
                        </v-card-text>
                    </v-card>
                </v-card-text>
            </v-tab-item>
        </v-tabs-items>
        </v-card>
        </v-main>
    </v-app>
</template>

<style scoped>
    .criteria {
        padding-top: 0px;
        padding-bottom: 0px;
    }
</style>
<script>

import Drawer from '@/components/Drawer.vue'
import DialogCreateAppointment from '@/components/Common/DialogCreateAppointment'
import FragmentCreateMember from '@/components/Common/FragmentCreateMember.vue'
import FragmentLinecount from './FragmentLinecount.vue'
import FragmentCalendar from './FragmentCalendar.vue'
import FragmentAppointmentTable from './FragmentAppointmentTable.vue'
import FragmentSelectStation from '@/components/Common/FragmentSelectStation.vue'
import FragmentSelectTimeRange from '@/components/Common/FragmentSelectTimeRange.vue'
import FragmentSelectGroup from '@/components/Common/FragmentSelectGroup.vue'
import FragmentSelectDateGroupTime from '@/components/Common/FragmentSelectDateGroupTime'

import axios from 'axios';
import config from '@/../config.js'
import Staff from '@/model/instance/Staff.js'

export default {
    components: {
        Drawer
        ,DialogCreateAppointment
        ,FragmentCreateMember
        ,FragmentLinecount
        ,FragmentCalendar
        ,FragmentAppointmentTable
        ,FragmentSelectStation
        ,FragmentSelectGroup
        ,FragmentSelectTimeRange
        ,FragmentSelectDateGroupTime
    },
    data () {
        return {

            tab : null,

            action_items : [],
            selected_id : [],
            selected_status_id : [],

            action_items_1 : [],
            selected_id_1 : [],
            selected_status_id_1 : [],

            action_items_2 : [],
            selected_id_2 : [],
            selected_status_id_2 : [],

            action_items_3 : [],
            selected_id_3 : [],
            selected_status_id_3 : [],

            dialog_create_appointment: false,
            dialog_create_member: false,
            dialog_continue_appointment: false,
            dialog_appointment_edit_date: false,
            dialog_appointment_edit_station: false,

            dialog_action_confirm: false,

            action_tab : 0,

            curMember: null,

            query_1: {
                station_code : this.$route.params.station_code
                ,fields : ["reservation_id","reservation_status_id","group_name","reservation_date","reservation_timestart","reservation_timeend","member_id","line_name","line_logo","callback_status","status_datetime","extranote","member_form_1","member_form_2","member_form_3","member_form_4","member_form_5","reservation_datestart","reservation_dateend"]
                ,query : {
                    station_code_list:[this.$route.params.station_code]
                    ,status_id_list:["2"]
                }
                ,order : ""
                ,page : 1
            },

            query_2: {
                station_code : this.$route.params.station_code
                ,fields : ["reservation_id","reservation_status_id","group_name","reservation_date","reservation_timestart","reservation_timeend","member_id","line_name","line_logo","callback_status","status_datetime","extranote","member_form_1","member_form_2","member_form_3","member_form_4","member_form_5","reservation_datestart","reservation_dateend"]
                ,query : {
                    station_code_list:[this.$route.params.station_code]
                    ,status_id_list:["4","5"]
                }
                ,order : ""
                ,page : 1
            },

            query_3: {
                station_code : this.$route.params.station_code
                ,fields : ["reservation_id","reservation_status_id","group_name","reservation_date","reservation_timestart","reservation_timeend","member_id","line_name","line_logo","callback_status","status_datetime","extranote","member_form_1","member_form_2","member_form_3","member_form_4","member_form_5","reservation_datestart","reservation_dateend"]
                ,query : {
                    station_code_list:[this.$route.params.station_code]
                    ,status_id_list:["1","6"]
                }
                ,order : ""
                ,page : 1
            },

            query : {
                station_code : this.$route.params.station_code
                ,fields : ["reservation_id","reservation_status_id","group_name","reservation_date","reservation_timestart","reservation_timeend","member_id","line_name","line_logo","callback_status","status_datetime","extranote","member_form_1","member_form_2","member_form_3","member_form_4","member_form_5","reservation_datestart","reservation_dateend"]
                ,query : {
                    station_code_list:[this.$route.params.station_code]
                    ,status_id_list:["2"]
                }
                ,order : ""
                ,page : 1
            },

            criteria: {
                startTime: '',
                endTime: '',
                isConfirm: true,
                isWaiting: true,
                isCancel: true,
                isCheckIn: true
            }

            ,last_reload : ""
            ,last_search : ""

            ,editDateDate : null
            ,editDateTimeStart :null
            ,editDateTimeEnd : null

            ,edit_station_editdatetime: false
            ,edit_station_editDateDate : null
            ,edit_station_editDateTimeStart : null
            ,edit_station_editDateTimeEnd : null

            ,editStationStationCode : this.$route.params.station_code
            ,editStationGroupId : null

            ,permission : []
            ,station_list : []
            ,group_list : []


            ,status_items : [
                {name:this.$i18n.t('reservation_status_1'),value:"1"}
                ,{name:this.$i18n.t('reservation_status_2'),value:"2"}
                ,{name:this.$i18n.t('reservation_status_3'),value:"3"}
                ,{name:this.$i18n.t('reservation_status_4'),value:"4"}
                ,{name:this.$i18n.t('reservation_status_5'),value:"5"}
                ,{name:this.$i18n.t('reservation_status_7'),value:"7"}
                ,{name:this.$i18n.t('reservation_status_8'),value:"8"}
                ,{name:this.$i18n.t('reservation_status_9'),value:"9"}
            ]
            ,selectedStatus : ["2"]
        }
    },
    computed: {
        isReady(){
            return this.editDateDate != null && this.editDateDate != undefined
            && this.editDateTimeStart != null && this.editDateTimeStart != undefined
            && this.editDateTimeEnd != null && this.editDateTimeEnd != undefined
        },
        isReady_station(){
            return this.editStationGroupId != null
        }
    },
    methods: {
        tableReload(tab){
            if(tab==0){
                if(this.selectedStatus.length>0){
                    this.query.query.status_id_list = this.selectedStatus
                    this.$refs.table.reload()
                    var date_search = new Date()
                    date_search.setHours(date_search.getHours()+7)
                    this.last_search = date_search.toISOString().substring(11,19)
                }
                this.$refs.table.reload()
            }else if(tab=='all'){
                this.$refs.table_1.reload()
                this.$refs.table_2.reload()
                this.$refs.table_3.reload()

                this.$refs.table.reload()
                var date = new Date()
                date.setHours(date.getHours()+7)
                this.last_reload = date.toISOString().substring(11,19)
            }else{
                this.$refs['table_' + tab].reload()
            }
        },
        onCreateAppointmentClosed() {
            this.dialog_create_appointment = false;
        },
        onCreateMemberClosed() {
            this.dialog_create_member = false;
        },
        onCreateAppointmentOpen() {
            this.dialog_create_appointment = true;
        },
        onCreateMemberOpen() {
            this.dialog_create_member = true;
        },
        onCreateMemberSuccess(member) {
            this.curMember = member
            this.curMember["display_name"] = member.line_name
            this.dialog_continue_appointment = true;
        },
        onCreateAppointmentSuccess(){
            this.dialog_create_appointment = false;
            this.tableReload('all')
            this.$refs.calendar.reload()
        },
        onContinueAppointment() {
            this.dialog_continue_appointment = false;
            this.onCreateAppointmentOpen()
            this.$refs.dialog_create_appointment.reset()
            this.$refs.dialog_create_appointment.nextStepOnSelectMember(this.curMember)
        },
        onCalendar(date){
            if(date==null){
                if(this.query.query["datee"] != undefined){
                    delete this.query.query["datee"]
                    var today = new Date()
                    today.setHours(today.getHours()+7)
                    this.query.query['datee_from'] = today.toISOString().substring(0,10)
                }
            }else{
                if(this.query.query["datee_from"] != undefined){
                    delete this.query.query["datee_from"]
                }
                this.query.query["datee"] = date;
            }
            this.tableReload(0)
        },
        onGroup(group,tab=0){
            var key = 'query'
            if(tab>0){
                key += '_' + tab
            }
            if(group.group_id==0){
                if(this[key].query["group_id"] != undefined){
                    delete this[key].query["group_id"]
                    this[key].query['group_list'] = this.group_list
                }
            }else{
                if(this[key].query["group_list"] != undefined){
                    delete this[key].query["group_list"]
                }
                this[key].query["group_id"] = group.group_id;
            }
            this.tableReload(tab);
        },
        onTimestart(timestart,tab=0){
            var key = 'query'
            if(tab>0){
                key += '_' + tab
            }
            if(timestart<0){
                if(this[key].query["timestart"] != undefined){
                    delete this[key].query["timestart"]
                }
            }else{
                this[key].query["timestart"] = timestart;
            }
            this.tableReload(tab);
        },
        onTimeend(timeend,tab=0){
            var key = 'query'
            if(tab>0){
                key += '_' + tab
            }
            if(timeend<0){
                if(this[key].query["timeend"] != undefined){
                    delete this[key].query["timeend"]
                }
            }else{
                this[key].query["timeend"] = timeend;
            }
            this.tableReload(tab);
        },
        onStatus(cb,list){
            if(cb){
                this.query.query.status_id_list = this.query.query.status_id_list.concat(list);
            }else{
                this.query.query.status_id_list = this.query.query.status_id_list.filter(e => !list.includes(e))
            }
            this.tableReload(0);
        },
        onTable(items,tab=0){
            var action_items_key = 'action_items'
            var selected_id_key = 'selected_id'
            var selected_status_id_key = 'selected_status_id'
            if(tab>0){
                action_items_key += '_' + tab
                selected_id_key += '_' + tab
                selected_status_id_key += '_' + tab
            }
            this[action_items_key] = []
            this[selected_id_key] = []
            if(items.length>0){
                this[selected_id_key] = items.map(r=>r.reservation_id)
                this[selected_status_id_key] = items.map(r=>r.reservation_status_id)
                if(
                    this.permission.includes('EDIT_action_approve') && (
                        items.every(r=>[1,3].includes(r.reservation_status_id))
                        || (items.some(r=>[1,3].includes(r.reservation_status_id)) && items.every(r=>[1,2,3].includes(r.reservation_status_id)))
                    )
                )this[action_items_key].push(2);

                if(
                    this.permission.includes('EDIT_action_cancel') && (
                        items.every(r=>[1,2].includes(r.reservation_status_id))
                        ||(items.some(r=>[1,2].includes(r.reservation_status_id)) && items.every(r=>[1,2,3].includes(r.reservation_status_id)))
                    )
                )this[action_items_key].push(1002);

                if(this.permission.includes('EDIT_action_postpone') && items.every(r=>[1,2,3,6,7,8].includes(r.reservation_status_id)))this[action_items_key].push(1000);
                if(this.permission.includes('EDIT_action_transfer') && items.every(r=>[1,2,3,6,7,8].includes(r.reservation_status_id)) && (this.station_list.length > 1 || this.group_list.length > 1))this[action_items_key].push(1001);

                if(this.permission.includes('EDIT_action_activate') && items.every(r=>r.reservation_status_id == 2))this[action_items_key].push(5);
            }
        },
        appointmentAction(to_status,tab=null){
            var selected_id_key = 'selected_id'
            var selected_status_id_key = 'selected_status_id'
            if(tab==null){
                tab = this.action_tab
            }
            this.action_tab = tab
            if(tab>0){
                selected_id_key += '_' + tab
                selected_status_id_key += '_' + tab
            }
            if(to_status==1000){
                this.dialog_appointment_edit_date = true
            }else if(to_status==1001){
                this.dialog_appointment_edit_station = true
                this.edit_station_editdatetime = false
                this.edit_station_editDateDate = null
                this.edit_station_editDateTimeStart = null
                this.edit_station_editDateTimeEnd = null
            }else if(to_status==1002){
                this.dialog_action_confirm = true
            }else if(to_status==8){
                var que1 = this.$store.commit('addLoading')
                var promises = []
                var list_3 = []
                var list_8 = []
                this[selected_status_id_key].forEach((s,i)=>{
                    if(s==1){
                        list_3.push(this[selected_id_key][i])
                    }else{
                        list_8.push(this[selected_id_key][i])
                    }
                })
                if(list_3.length>0){
                    promises.push(axios.post(config.api.url.manage.appointment.manage.edit_status,{
                        reservation_id_list:list_3
                        ,to_status:3
                        ,station_code : this.$route.params.station_code
                    },{ headers: Staff.getTokenHeader()}))
                }
                if(list_8.length>0){
                    promises.push(axios.post(config.api.url.manage.appointment.manage.edit_status,{
                        reservation_id_list:list_8
                        ,to_status:8
                        ,station_code : this.$route.params.station_code
                    },{ headers: Staff.getTokenHeader()}))
                }

                Promise.all(promises)
                .then(() => {
                    this.$store.commit('finishLoading',que1)
                    if(tab==0){
                        this.tableReload(0);
                    }
                    this.tableReload('all');
                })
            }
            else{
                var que = this.$store.commit('addLoading')
                axios.post(config.api.url.manage.appointment.manage.edit_status,{
                    reservation_id_list:this[selected_id_key]
                    ,to_status:to_status
                    ,station_code : this.$route.params.station_code
                },{ headers: Staff.getTokenHeader()})
                .then(() => {
                    this.$store.commit('finishLoading',que)
                    if(tab==0){
                        this.tableReload(0);
                    }
                    this.tableReload('all');
                })
            }
        },
        appointmentEditDate(){
            var selected_id_key = 'selected_id'
            if(this.action_tab>0){
                selected_id_key += '_' + this.action_tab
            }
            var que = this.$store.commit('addLoading')
            axios.post(config.api.url.manage.appointment.manage.edit_date,{
                reservation_id_list:this[selected_id_key]
                ,station_code : this.$route.params.station_code
                ,reservation_date:this.editDateDate
                ,reservation_timestart:this.editDateTimeStart
                ,reservation_timeend:this.editDateTimeEnd
            },{ headers: Staff.getTokenHeader()})
            .then(() => {
                this.dialog_appointment_edit_date = false
                this.$store.commit('finishLoading',que)
                
                this.tableReload(0);
                this.tableReload('all');
            })
        },
        appointmentEditStation(){
            var selected_id_key = 'selected_id'
            if(this.action_tab>0){
                selected_id_key += '_' + this.action_tab
            }
            var que = this.$store.commit('addLoading')
            axios.post(config.api.url.manage.appointment.manage.edit_station,{
                reservation_id_list:this[selected_id_key]
                ,station_code : this.$route.params.station_code
                ,group_id:this.editStationGroupId
                ,reservation_date:this.edit_station_editDateDate
                ,reservation_timestart:this.edit_station_editDateTimeStart
                ,reservation_timeend:this.edit_station_editDateTimeEnd
            },{ headers: Staff.getTokenHeader()})
            .then(() => {
                this.dialog_appointment_edit_station = false
                this.$store.commit('finishLoading',que)
                this.tableReload(0);
                this.tableReload('all');
            })
        },
        onStationChange(station){
            document.location = station.station_code
        }
    },
    mounted(){
        var today = new Date()
        today.setHours(today.getHours()+7)
        this.query_1.query['datee'] = today.toISOString().substring(0,10)
        this.query_2.query['status_datee'] = today.toISOString().substring(0,10)

        var que = this.$store.commit('addLoading')
        this.$store.getters.getStationList
        .then(result=>{
            this.station_list = result
        }).catch(error => {
            this.$router.push({name:'Error',params:error}) 
        })
        this.permission = Staff.getPermission('AppointmentList',this.$route.params.station_code).then(permission=>{
            this.permission = permission
            axios
            .post(config.api.url.manage.appointment.manage.get_grouplist,{station_code:this.$route.params.station_code},{headers: Staff.getTokenHeader()})
            .then(response => {
                this.$store.commit('finishLoading',que)
                this.group_list = response.data.grouplist.map(g=>g.group_id)
                this.query_1.query['group_list'] = this.group_list
                this.query_2.query['group_list'] = this.group_list
                this.query_3.query['group_list'] = this.group_list
                this.query.query['group_list'] = this.group_list
                this.tableReload('all');
            })
            .catch(error => {
                this.$router.push({name:'Error',params:error}) 
            })
        })
    }
}
</script>